import React, { FC } from 'react';

const EyeIcon: FC = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M0.833374 9.99992C0.833374 9.99992 4.16671 3.33325 10 3.33325C15.8334 3.33325 19.1667 9.99992 19.1667 9.99992C19.1667 9.99992 15.8334 16.6666 10 16.6666C4.16671 16.6666 0.833374 9.99992 0.833374 9.99992Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EyeIcon;
